/**
 *
 * FormTabs
 *
 * This is purely presentational and has state that is maintained by external
 * reducers and actions provided by the contianer this is used by.
 *
 * `renderForm` must be a function that returns a component to be rendered in
 * each tab
 *
 */

import React from "react";
import { Wrapper, Nav, Title, Button, Ul } from "./styledComponents";
import FormTab from "./FormTab";

import H1 from "components/H1";

class FormTabs extends React.PureComponent {
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.currentTab !== this.props.currentTab) {
      const root = document.getElementById("root");
      if (root && root.childNodes[0]) {
        root.childNodes[0].scrollTop = 0;
      }
    }
  }

  tabId = (i) => `form-tab-${i}`;

  panelId = (i) => `form-tabpanel-${i}`;

  handleTabKeyDown = (e, index) => {
    const { tabs, currentTab, onTabChange, isNew } = this.props;
    const last = tabs.length - 1;
    let next = index;
    switch (e.key) {
      case "ArrowRight":
        next = Math.min(index + 1, last);
        break;
      case "ArrowLeft":
        next = Math.max(index - 1, 0);
        break;
      case "Home":
        next = 0;
        break;
      case "End":
        next = last;
        break;
      default:
        return;
    }
    e.preventDefault();
    const nextEl = document.getElementById(this.tabId(next));
    if (nextEl) nextEl.focus();
    const tab = tabs[next];
    const disabledOthers = isNew && next > currentTab;
    if (tab && !tab.disabled && !disabledOthers && onTabChange) {
      onTabChange(next);
    }
  };

  render() {
    const {
      onTabChange,
      tabs,
      currentTab,
      formTitle,
      onCancel,
      isNew,
      afterForm,
    } = this.props;
    const { renderForm, disabled } = tabs[currentTab] || tabs[0];

    return (
      <Wrapper>
        <Nav>
          <Title>
            <H1>{formTitle}</H1>
            {onCancel && (
              <Button
                className="cancel"
                onClick={onCancel}
                hidden={this.props.pristine}
              >
                Cancel
              </Button>
            )}
          </Title>
          <Ul role="tablist">
            {tabs.map((tab, i) => (
              <FormTab
                key={i}
                {...tab}
                id={this.tabId(i)}
                panelId={this.panelId(i)}
                isActive={currentTab === i}
                onClick={() => {
                  if (onTabChange) {
                    onTabChange(i);
                  }
                }}
                onKeyDown={(e) => this.handleTabKeyDown(e, i)}
                disabledOthers={isNew && i > currentTab}
              />
            ))}
          </Ul>
        </Nav>
        <div
          role="tabpanel"
          id={this.panelId(currentTab)}
          aria-labelledby={this.tabId(currentTab)}
        >
          {renderForm({ disabled })}
          {afterForm}
        </div>
      </Wrapper>
    );
  }
}

export default FormTabs;
